import { render } from "./RealtimeUnsuccessful.vue?vue&type=template&id=b763051e&scoped=true"
import script from "./RealtimeUnsuccessful.vue?vue&type=script&lang=js"
export * from "./RealtimeUnsuccessful.vue?vue&type=script&lang=js"

import "./RealtimeUnsuccessful.vue?vue&type=style&index=0&id=b763051e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b763051e"]])

export default __exports__